import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { tournamentService } from '@/services/tournament';

export function useTournamentCycle() {
    const { executeAction } = useCrudActions();

    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const { list, total, fetchList } = useBaseListView({
        request: tournamentService.cycle.list,
        paramsBuilder: () => ({ ...query }),
        hooks: {
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute,
            transformResponse: async (cycles: any[]) => {
                const leaderboardIds = new Set(cycles.map(cycle => cycle.tournamentLeaderboardId));
                const leaderboardNames = await getLeaderboardNameList(leaderboardIds);

                return cycles.map(cycle => ({
                    ...cycle,
                    leaderboardName: leaderboardNames.get(cycle.tournamentLeaderboardId)
                }));
            }
        }
    });

    const getLeaderboardNameList = async (leaderboardIds: Set<number>) => {
        let leaderboardNames: Map<number, string> = new Map();
        await executeAction({
            request: () => tournamentService.leaderboard.getList(Array.from(leaderboardIds).join(',')),
            onSuccess: ({ data }) => {
                leaderboardNames = new Map<number, string>(data.map((item: any) => [item.id, item.name]));
            }
        })();

        return leaderboardNames;
    };

    return { list, total, query, fetchList };
}
